<template>
  <div class="app-container config-list">
    <el-tabs v-model="activeName" @tab-click="onTabShow">
      <el-tab-pane  label="应用配置" name="config">
          <div class="config-list-filter">
            <el-row>
              <el-col :span="6">
                <div class="grid-content bg-purple">
                  <el-input class="config-list-filter-value" v-model.trim="search.title" @keyup.enter.native="searchChange" placeholder="应用标题" clearable size="small" suffix-icon="el-icon-search"></el-input>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="grid-content bg-purple">
                  <el-select class="config-list-filter-value" placeholder="分组" v-model="search.groupId" clearable size="small">
                    <template>
                      <el-option
                        v-for="item in groupList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </template>
                  </el-select>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="grid-content bg-purple">
                  <el-select class="config-list-filter-value" placeholder="状态" v-model="search.isBanned" clearable size="small">
                    <el-option
                      v-for="item in bannedOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </div>
              </el-col>
              <el-col :span="6">
                <div>
                  <el-button class="config-list-filter-search" size="small" @click="searchChange">立即筛选</el-button>
                  <el-button class="config-list-filter-reset" size="small" @click="searchReset">清除条件</el-button>
                </div>
              </el-col>
            </el-row>
          </div>
          <basic-container class = "config-list-container">
            <avue-crud ref="crud"
                      :option="tableOption"
                      :data="tableData"
                      :page="page"
                      :table-loading="tableLoading"
                      :before-open="handleOpenBefore"
                      @refresh-change="getData"
                      @current-change="handleCurrentChange"
                      @size-change="handleSizeChange">

              <template slot="menuLeft">
                <el-button type="primary" @click="handleAdd" icon="el-icon-plus" size="small" v-if="permissions.app_config_add">新增内容</el-button>
              </template>
              <template slot="coverUrl" slot-scope="scope" >
                <img :ref="coverUrl" class="image-url-options" :src="scope.row.coverUrl">
              </template>
              <template slot="path" slot-scope="scope">
                <el-button type="text" @click="previewImg(scope.row.qrUrl)">
                  <div>{{scope.row.path}}</div>
                </el-button>
              </template>
              <template slot="isBanned" slot-scope="scope" >
                {{scope.row.isBanned ? '已下架' : '已上架'}}
              </template>
              <template slot-scope="scope"
                        slot="menu">
                <el-button type="text"
                          v-if="permissions.app_config_edit"
                          icon="el-icon-edit"
                          size="mini"
                          @click="handleConfigUpdate(scope.row,scope.index)">编辑</el-button>
                <el-button type="text"
                          v-if="permissions.app_config_edit && !scope.row.isBanned"
                          icon="el-icon-download"
                          size="mini"
                          @click="handleDown(scope.row,scope.index)">下架</el-button>
                <el-button type="text"
                          v-if="permissions.app_config_edit && scope.row.isBanned"
                          icon="el-icon-upload2"
                          size="mini"
                          @click="handleUp(scope.row,scope.index)">上架</el-button>
                <el-button type="text"
                          v-if="permissions.app_config_del"
                          icon="el-icon-delete"
                          size="mini"
                          :disabled="!scope.row.isBanned"
                          title="上架状态的无法删除"
                          @click="handleDelete(scope.row,scope.index)">删除</el-button>

              </template>
            </avue-crud>
          </basic-container>
            <el-dialog
              title="投票详情"
              :visible.sync="imgDialogVisible"
              fullscreen
              custom-class="preview-img-dialog">
              <div @click="imgDialogVisible = false">
                <vue-qr :text="previewImgUrl" :size="qrCodeSize"></vue-qr>
              </div>
            </el-dialog>
      </el-tab-pane>
      <el-tab-pane label="页面分组" name="group">
        <group/>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  import {fetchAppConfigList, removeAppConfig, getAppGroupDrop, updateConfigBanStatus} from '@/api/app/config'
  import {listTableOption} from '@/const/crud/app/config'
  import {mapGetters} from "vuex";
  import group from './group.vue'
  import vueQr from 'vue-qr'

  export default {
    name: "table_app_config",
    components: {
        group,
        vueQr
    },
    data() {
      return {
        tableOption: listTableOption,
        bannedOptions: [
          { label: '已下架', value: true },
          { label: '已上架', value: false },
        ],
        imgDialogVisible: false,
        previewImgUrl: '',
        qrCodeSize: 300,
        search: {
          current: 1,
          size: 10,
          title: '',
          isBanned: '',
          groupId: ''
        },
        activeName: "config",
        groupList: [],
        // 列表页面
        tableData:[],
        page: {
          total: 0, // 总页数
          currentPage: 1, // 当前页数
          pageSize: 10, // 每页显示多少条,
        },
        tableLoading: false,
      };
    },
    created() {
      this.getList();
    },
    computed: {
      ...mapGetters(['permissions']),
    },
    activated() {
      this.getList();
    },
    methods: {
     async getList() {
        this.getAppGroupDrop();
        let params = {
          current: this.search.current,
          size: this.search.size
        }

        if (this.search.title != "" && this.search.title.trim() != "")
          params.title = this.search.title
        if (this.search.isBanned !== null && this.search.isBanned !== "")
          params.isBanned = this.search.isBanned;
        if (this.search.groupId !== null && this.search.groupId !== "")
          params.groupId = this.search.groupId;

        this.tableLoading = true
        fetchAppConfigList(params).then(response => {
          this.tableData = response.data.data.records;
          this.page.total = response.data.data.total
          this.tableLoading = false
        })
      },
      initPage() {
        this.page.currentPage = 1
        this.page.pageSize = this.search.size
        this.search.current = 1
      },
      getAppGroupDrop() {
        this.groupList = [];
        getAppGroupDrop().then(res => {
          let list = res.data.data
          list.forEach(item => {
            this.groupList.push({ label: item.groupName, value: item.id })
          });
        });
      },
      searchChange() {
        this.initPage()
        this.getList()
      },
      searchReset() {
        this.search.title = "";
        this.search.isBanned = "";
        this.search.groupId = "";
        this.searchChange()
      },
      handleCurrentChange(val) {
        this.page.currentPage = val
        this.search.current = val
        this.getList()
      },
      handleSizeChange(val) {
        this.page.pageSize = val
        this.search.size = val
        this.getList()
      },
      handleUp(row, index) {
        let _this = this
        this.$confirm('是否确认上架该标题为"' + row.title + '"'+ '的应用?', '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          return updateConfigBanStatus({id: row.id, isBanned: false});
        }).then(() => {
          this.getList()
          _this.$message({
            showClose: true,
            message: '上架成功',
            type: 'success'
          })
        }).catch(function () {
        })
      },
      handleDown(row, index) {
        let _this = this
        this.$confirm('是否确认下架该标题为"' + row.title + '"'+ '的应用?', '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          return updateConfigBanStatus({id: row.id, isBanned: true});
        }).then(() => {
          this.getList()
          _this.$message({
            showClose: true,
            message: '下架成功',
            type: 'success'
          })
        }).catch(function () {
        })
      },
      handleOpenBefore(show, type) {
        show();
      },
      handleAdd() {
        this.$router.push({path: '/app/config/add'})
      },
      
      handleDelete(row) {
        this.$confirm('确定要删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          removeAppConfig(row.id).then(response => {
            if (response.data.data) {
              this.$message({
                message: '删除成功',
                type: 'success'
              })
              this.getList()
            }
          }).catch(error => {
            this.$message({
              message: '删除失败',
              type: 'error'
            })
          })
        })
      },
      handleConfigUpdate(row) {
        this.$router.push({path: `/app/config/edit/${row.id}`,})
      },
      previewImg(url) {
        this.previewImgUrl = url;
        this.imgDialogVisible = true;
      },
    }
  };

</script>


<style lang="scss" scoped>

.config-list {
  padding-left: 22px;
  background: #fff;

  &-filter {
    margin: 0px 10px;
    background-color: #fff;
    padding-top: 20px;
    padding-left: 22px;

    &-label {
      font-size: 14px;
      color: #606266;
      margin-right: 10px;
    }

    &-value {
      width: 96%!important;
    }

    &-date {
      width: 96%!important;
    }

    &-reset {
      float: right;
      margin-right: 8px;
    }

    &-search {
      float: right;
      margin-right: 10px;
      border-color: #5383f3;
      color: #5383f3;
    }
  }

  &-container {
    padding-top: 0px;
    &-button {
      color: #409EFF;
      font-size: 14px;
      text-align: center;
      font-weight: 500;
    }
  }
  .clamp-text {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }
}
/deep/.el-dialog__body {
  padding : 10px 20px 10px 20px;
}
/deep/.el-input-number {
  line-height: 36px;
}

.title {
  display: flex;
  align-items: center;
  .post-cover-image {
    display: flex;
    width: fit-content;
    margin-right: 12px;
    cursor: pointer;
    img {
      width: 40px;
      height: 40px;
      object-fit: cover;
      max-width: 100%;
    }
  }
}
.image-url-options{
  width: 50px;
  height: 50px;
  border-radius: 6px;
  margin-right: 8px;
  float: left;
  object-fit: cover;
}
.post-top-dialog {
  height: 90px;
  &-item {
    display: flex;
    flex-direction: row;
    justify-content: center;
    &-label {
      font-size: 15px;
      color: #606266;
      padding: 10px;
    }
    &-content {
      width: 200px !important;
    }
    &-tip {
      font-size: 12px;
      color: #999999;
      margin-bottom: 10px;
      margin-top: 6px;
    }
    &-value {
      width: 200px;
    }
  }
}
.manual-input-label{
    font-size: 15px;
    color: #606266;
    padding: 10px;
}
.hide-redundant-post-images {
  display: none;
}
.down-dialog-item-label {
  display: inline-block;
  margin: 10px 0;
}
/deep/ .el-dialog.preview-img-dialog{
  background: rgba(0, 0, 0, 0.5);
  .el-dialog__header {
    padding: 0;
    .el-dialog__headerbtn {
      top: 40px;
      right: 40px;
      .el-dialog__close {
        font-size: 20px;
        color: #fff;
        font-weight: bold;
        border: 2px solid #fff;
        border-radius: 50%;
        padding: 5px;
      }
    }
  }
  .el-dialog__body {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 0;
    img {
      max-height: 100%;
      max-width: 100%;
    }
  }
}
</style>
